module.exports = __webpack_public_path__ + "img/mystery_box_w.1413acb6.png";